var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22723 1.40439e-08C5.23416 8.4615e-05 4.2555 0.237646 3.37291 0.692863C2.49032 1.14808 1.72939 1.80775 1.15361 2.61685C0.577831 3.42594 0.203895 4.36099 0.0629995 5.34398C-0.0778956 6.32698 0.0183362 7.32941 0.343666 8.26765C0.668997 9.20589 1.21399 10.0527 1.93318 10.7375C2.65237 11.4223 3.5249 11.9252 4.47797 12.2042C5.43105 12.4832 6.43703 12.5303 7.41199 12.3414C8.38694 12.1526 9.30261 11.7334 10.0826 11.1187L12.7583 13.7943C12.8965 13.9278 13.0816 14.0016 13.2737 14C13.4658 13.9983 13.6496 13.9213 13.7854 13.7854C13.9212 13.6496 13.9983 13.4658 14 13.2737C14.0016 13.0816 13.9278 12.8965 13.7943 12.7584L11.1186 10.0827C11.8425 9.16444 12.2932 8.06091 12.4192 6.89843C12.5451 5.73595 12.3413 4.56149 11.8309 3.50946C11.3206 2.45743 10.5243 1.57033 9.5333 0.949684C8.54229 0.329038 7.39656 -7.84986e-05 6.22723 1.40439e-08ZM1.46483 6.22753C1.46483 4.96451 1.96658 3.75321 2.8597 2.86012C3.75283 1.96703 4.96416 1.4653 6.22723 1.4653C7.4903 1.4653 8.70164 1.96703 9.59476 2.86012C10.4879 3.75321 10.9896 4.96451 10.9896 6.22753C10.9896 7.49055 10.4879 8.70184 9.59476 9.59493C8.70164 10.488 7.4903 10.9898 6.22723 10.9898C4.96416 10.9898 3.75283 10.488 2.8597 9.59493C1.96658 8.70184 1.46483 7.49055 1.46483 6.22753Z",
    fill: "#A2A6AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.29318c75dbbbf994885481be4505ce86.svg";
export { ForwardRef as ReactComponent };